'use client';

import { useRouter } from 'next/navigation';
import { getDynamicEnvVarsInClient } from '@/utils/envHelper';
import { setCookie } from 'cookies-next';
import { IoLogoLinkedin } from 'react-icons/io5';

import { Button } from '@/components/ui';

const LinkedInButton = ({
  text,
  signInPage = false,
  checked,
}: {
  text: string;
  signInPage: boolean;
  checked?: boolean;
}) => {
  const router = useRouter();

  const { NEXT_PUBLIC_CW_AUTH_URL } = getDynamicEnvVarsInClient();

  const handleLinkedInClick = () => {
    const fullUrl = `${window.location.href}`;
    setCookie('furl', fullUrl);
    setCookie('signInPage', signInPage);
    const callbackURL = `${window.location.origin}/auth/ui/auth/linkedin/callback`;
    router.push(
      `${NEXT_PUBLIC_CW_AUTH_URL}/linkedin?callbackURL=${callbackURL}`
    );
  };

  return (
    <Button
      onClick={handleLinkedInClick}
      disabled={!signInPage && !checked}
      className="mt-2"
      variant="outline"
      size="fullWidth"
    >
      <IoLogoLinkedin className="mr-2 h-[15px] w-[15px]" /> {text}
    </Button>
  );
};
export default LinkedInButton;
